import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { DotScreenShader } from '../components/DotScreenShader';
import { Footer } from '../components/Footer';


export const SignInPage = ({
    onAuthSubmit,
    onOAuth,
    oAuthLoading,
    authLoading,
    authError,
    authEmail,
    setAuthEmail,
    authPassword,
    setAuthPassword
}) => {
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const success = await onAuthSubmit(e, 'sign_in');
        if (success) {
            navigate('/');
        }
    };

    return (
        <div className="App" style={{ position: 'relative' }}>
            <div style={{ position: 'fixed', inset: 0, zIndex: 0 }}>
                <DotScreenShader theme="dark" />
            </div>

            <Navbar />

            <main className="hero hero--auth hero--auth-signin" style={{ position: 'relative', zIndex: 1, paddingTop: '100px' }}>
                <div className="auth-page">
                    <div className="signup-card">
                        <p className="hero-preheader hero-preheader--centered">#1 AI FACELESS VIDEO TOOL</p>
                        <h1 className="hero-heading hero-heading--centered">Sign In</h1>
                        <p className="hero-subheader">Get back to business</p>
                    </div>

                    <section className="signup-form-card">
                        <button type="button" className="oauth-btn" onClick={() => onOAuth(false)} disabled={oAuthLoading}>
                            {oAuthLoading ? (
                                <>
                                    <span className="oauth-spinner"></span>
                                    Connecting...
                                </>
                            ) : (
                                <>
                                    <svg className="oauth-icon" viewBox="0 0 48 48" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                                        <path fill="none" d="M0 0h48v48H0z" />
                                    </svg>
                                    Continue with Google
                                </>
                            )}
                        </button>

                        <div className="auth-divider">or continue with email</div>

                        <form onSubmit={handleSubmit}>
                            <input
                                id="signin-email"
                                type="email"
                                required
                                value={authEmail}
                                onChange={(e) => setAuthEmail(e.target.value)}
                                placeholder="Enter email address"
                            />
                            <input
                                id="signin-password"
                                type="password"
                                required
                                value={authPassword}
                                onChange={(e) => setAuthPassword(e.target.value)}
                                minLength={6}
                                placeholder="Enter password"
                            />
                            <button type="submit" disabled={authLoading}>
                                {authLoading ? 'Submitting…' : 'Sign in'}
                            </button>
                        </form>
                        {authError && <p className="error">{authError}</p>}
                        <p className="auth-toggle">
                            Need an account? <Link to="/signup">Sign up</Link>
                        </p>
                    </section>
                </div>
            </main>

            <div style={{ position: 'relative', zIndex: 1 }}>
                <Footer />
            </div>
        </div>
    );
};
